import http from "./httpClient.js";

export async function saveDanceStyle(data, payloadToken) {
    const response = await http.post(`/dance-style`, data, {
        headers: {
            Authorization: `Bearer ${payloadToken}`
        }
    });
    return response.data;
}

export async function getAllDanceStyle(payloadToken, schoolId) {
    const response = await http.get(`/school/${schoolId}/dance-style`, {
        headers: {
            Authorization: `Bearer ${payloadToken}`
        }
    });
    return response.data;
}

export async function updateDanceStyle(id, data, payloadToken) {
    const response = await http.patch(`/dance-style/${id}`, data, {
        headers: {
            Authorization: `Bearer ${payloadToken}`
        }
    });
    return response.data;
}

export async function deleteDanceStyle(id, payloadToken) {
    const response = await http.delete(`/dance-style/${id}`, {
        headers: {
            Authorization: `Bearer ${payloadToken}`
        }
    });
    return response.data;
}